import template from './differential.html';
import controller from './differential.controller';
import './differential.scss';

let differentialComponent = {
  bindings: {},
  template,
  controller
};

export default differentialComponent;



// WEBPACK FOOTER //
// ./client/app/components/differential/differential.component.js